import { Component, OnDestroy, OnInit } from "@angular/core"
import { AuthService } from "src/app/services/auth.service"
import { Validators } from "@angular/forms"
import { FormBuilder } from "@angular/forms"
import { Subscription } from "rxjs"

@Component({
	selector: "app-contact",
	templateUrl: "./contact.component.html",
	styleUrls: ["./contact.component.scss"]
})
export class ContactComponent implements OnInit {
	public waitLogin = false
	public userData: {
		name: string
		surname: string
		email: string
		company: string
		country: string
	}
	public message: string

	public contactForm = this.fb.group({
		message: ["", Validators.required]
	})

	constructor(
		private authService: AuthService,
		private fb: FormBuilder
	) {}

	ngOnInit() {
		this.getUserData()
	}

	get disabled() {
		if (this.contactForm && this.contactForm.valid) {
			return false
		} else {
			return true
		}
	}

	public getUserData() {
		this.authService.getUserData().subscribe(res => {
			this.userData = res
		})
	}

	onSubmit() {
		if (this.disabled) {
			return
		}
		this.waitLogin = true
		const req = {
			user: this.userData,
			message: this.message
		}
		this.authService.sendMessage(req).subscribe(
			res => {
				this.contactForm.markAsUntouched()
				this.waitLogin = false
				this.authService.showSuccess(res.message)
			},
			err => {
				this.authService.showError(err)
				this.waitLogin = false
			}
		)
	}
}
